import { createFileRoute } from '@tanstack/react-router'

import { LoginPage } from '@/pages/LoginPage'

export const Route = createFileRoute('/login')({
  validateSearch: search => {
    if (!search.redirectTo) {
      return {}
    }
    return {
      redirectTo: (search.redirectTo ?? undefined) as string | undefined,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { redirectTo } = Route.useSearch()
  return <LoginPage redirectTo={redirectTo} />
}
